var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHipClinicalModuleColoured(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HIP Clinical Module copy"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.332 21.304C19.444 20.48 18.888 19.304 18.888 18C18.888 16.696 19.444 15.5201 20.332 14.696C20.572 14.472 20.836 14.276 21.12 14.112C22.008 13.288 22.564 12.112 22.564 10.808C22.564 8.32005 20.544 6.30005 18.052 6.30005C15.56 6.30005 13.54 8.32005 13.54 10.808C13.54 12.112 14.096 13.288 14.984 14.112C15.268 14.276 15.532 14.476 15.772 14.696C16.66 15.5201 17.216 16.696 17.216 18C17.216 19.304 16.66 20.48 15.772 21.304C15.532 21.528 15.268 21.724 14.984 21.888C14.096 22.712 13.54 23.888 13.54 25.192C13.54 27.68 15.56 29.7 18.052 29.7C20.544 29.7 22.564 27.684 22.564 25.192C22.564 23.888 22.008 22.712 21.12 21.888C20.836 21.724 20.572 21.524 20.332 21.304Z",
    fill: "#008AED"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8121 16.3C28.2121 17.728 27.5921 20.388 24.9761 20.712C22.3721 20.332 21.7961 17.664 23.2201 16.264C24.2201 15.28 25.8281 15.296 26.8121 16.3Z",
    fill: "#008AED"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8121 16.3C14.2121 17.728 13.5921 20.388 10.9761 20.712C8.3721 20.332 7.79609 17.664 9.22009 16.264C10.2201 15.28 11.8281 15.296 12.8121 16.3Z",
    fill: "#008AED"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHipClinicalModuleColoured);
export default __webpack_public_path__ + "static/media/HIP Clinical Module Coloured.0acefbf823478edd0b34ce5cd9144b97.svg";
export { ForwardRef as ReactComponent };